module.exports = __webpack_public_path__ + "static/img/4.d0a34d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/4.png
// module id = 6ukU
// module chunks = 0